export const loanConstants = {
	loanAccount: {
		fields: {
			loanRepaymentStatus: 'loanRepaymentStatus'
		}
	},
	loanRepaymentStatuses: [
		{
			display: 'Repayment',
			value: 'IN_REPAYMENT',
			tooltip: 'Required to make monthly payments to loan servicer.'
		},
		{
			display: 'Late / Past Due',
			value: 'LATE_PAST_DUE',
			tooltip: 'Missed one or more scheduled payments.'
		},
		{
			display: 'Grace Period',
			value: 'IN_GRACE_PERIOD',
			tooltip: 'No payments required for a set period of time after leaving school.'
		},
		{
			display: 'Deferment / Forbearance',
			value: 'DEFERMENT_FORBEARANCE',
			tooltip: 'Payments are temporarily postponed or reduced.'
		},
		{
			display: 'In School',
			value: 'IN_SCHOOL',
			tooltip: 'Currently enrolled and not required to make payments.'
		},
		{
			display: 'Delinquency / Default (In Collection)',
			value: 'DEFAULTED_IN_COLLECTION',
			tooltip: 'Failed to make payments for an extended period.'
		},
		{
			display: 'Other / Unknown',
			value: 'OTHER_UNKNOWN',
			tooltip: ''
		}
	],
	loanDefaultedStatusValue: 'DEFAULTED',
	loanDefaultedStatusDisplayValue: 'Delinquency / Default (In Collection)',
	loanForbearanceStatusValue: 'FORBEARANCE',
	loanDefermentStatusValue: 'DEFERMENT',
	loanDefermentForbearanceStatusDisplayValue: 'Deferment / Forbearance'
};
